module.exports = __webpack_public_path__ + "img/horizontal_3_5_3016.5d5bbe71.png";